import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["requisitionSelect", "customerSelect", "contactSelect", "titleField", "hourlyRateField", "projectLocationField"]

  connect() {
    this.initializeForm()
  }

  initializeForm() {
    // Wenn eine Requisition bereits vorausgewählt ist, fülle die Felder aus
    if (this.requisitionSelectTarget.value) {
      this.requisitionChanged()
    }
  }

  // async requisitionChanged() {
  //   const requisitionId = this.requisitionSelectTarget.value
  //   console.log('Requisition geändert zu ID:', requisitionId)
    
  //   if (!requisitionId) {
  //     console.log('Keine Requisition ausgewählt')
  //     return
  //   }

  //   try {
  //     console.log('Lade Requisition-Daten für ID:', requisitionId)
  //     const response = await fetch(`/backend/requisitions/${requisitionId}/quote_data`, {
  //       headers: {
  //         'Accept': 'application/json',
  //         'X-Requested-With': 'XMLHttpRequest'
  //       }
  //     })

  //     if (response.ok) {
  //       const data = await response.json()
  //       console.log('Requisition-Daten erfolgreich geladen:', data)
        
  //       // Datenübernahme temporär deaktiviert
  //       console.log('Datenübernahme ist temporär deaktiviert')
  //       this.showNotification("Daten geladen, aber Übernahme ist deaktiviert", "info")
        
  //       // Optional: Zeige die geladenen Daten in der Konsole
  //       console.table({
  //       //   'Kunde ID': data.customer_id,
  //       //   'Kontakt ID': data.contact_id,
  //       //   'Titel': data.title,
  //       //   'Stundensatz': data.hourly_rate,
  //       //   'Einsatzort': data.site
  //       // })
        
  //     } else {
  //       console.error('Fehler beim Laden der Requisition-Daten:', response.status, response.statusText)
  //       this.showNotification("Fehler beim Laden der Anfrage-Daten", "error")
  //     }
  //   } catch (error) {
  //     console.error('Fehler beim Laden der Requisition-Daten:', error)
  //     this.showNotification("Fehler beim Laden der Anfrage-Daten", "error")
  //     }
  // }

  shouldOverwriteExistingData() {
    // Prüfe, ob bereits Daten in den Feldern stehen
    const hasExistingData = (
      (this.hasTitleField && this.titleFieldTarget.value.trim() !== '') ||
      (this.hasCustomerSelectTarget && this.customerSelectTarget.value !== '') ||
      (this.hasContactSelectTarget && this.contactSelectTarget.value !== '') ||
      (this.hasHourlyRateField && this.hourlyRateFieldTarget.value.trim() !== '') ||
      (this.hasProjectLocationField && this.projectLocationFieldTarget.value.trim() !== '')
    )

    if (!hasExistingData) {
      // Keine bestehenden Daten, übernehme direkt
      return true
    }

    // Bestätigungsabfrage, wenn bereits Daten vorhanden sind
    return confirm(
      'Es sind bereits Daten in den Feldern vorhanden. ' +
      'Möchten Sie diese mit den Daten aus der ausgewählten Anfrage überschreiben?'
    )
  }

  fillRequisitionFields(data) {
    // Fülle die Felder mit den Requisition-Daten aus
    if (this.hasCustomerSelectTarget && data.customer_id) {
      this.customerSelectTarget.value = data.customer_id
      this.customerSelectTarget.dispatchEvent(new Event('change'))
    }

    if (this.hasContactSelectTarget && data.contact_id) {
      this.contactSelectTarget.value = data.contact_id
    }

    // Titel mit dem reinen Anfragentitel vorbelegen (kein "Angebot für …"), Kundenwunsch Lorenz
    if (this.hasTitleField && data.title) {
      this.titleFieldTarget.value = data.title
    }

    if (this.hasHourlyRateField && data.hourly_rate) {
      this.hourlyRateFieldTarget.value = data.hourly_rate
    }

    if (this.hasProjectLocationField && data.site) {
      this.projectLocationFieldTarget.value = data.site
    }

    // Zeige Erfolgsmeldung
    this.showNotification("Anfrage-Daten wurden erfolgreich übernommen", "success")
  }

  clearRequisitionFields() {
    // Lösche die vorausgefüllten Felder
    if (this.hasContactSelectTarget) {
      this.contactSelectTarget.value = ''
    }

    if (this.hasTitleField) {
      this.titleFieldTarget.value = ''
    }

    if (this.hasHourlyRateField) {
      this.hourlyRateFieldTarget.value = ''
    }

    if (this.hasProjectLocationField) {
      this.projectLocationFieldTarget.value = ''
    }
  }

  showNotification(message, type = "info") {
    // Einfache Benachrichtigung
    const notification = document.createElement('div')
    notification.className = `fixed top-4 right-4 p-4 rounded-md shadow-lg z-50 ${
      type === 'success' ? 'bg-green-500 text-white' : 
      type === 'error' ? 'bg-red-500 text-white' : 
      'bg-blue-500 text-white'
    }`
    notification.textContent = message
    
    document.body.appendChild(notification)
    
    // Nach 3 Sekunden entfernen
    setTimeout(() => {
      notification.remove()
    }, 3000)
  }
}
